// @flow

import { sendSpecialChatbot } from '../api/chatchampApi'
import { logger } from '../logger'

import { geAddToCartFunction } from './addToCartFunctions'

type StrategyType = 'wizard' | 'chatbot'

export class AddToCartStrategy {
  strategyType: StrategyType

  constructor (strategyType: 'wizard' | 'chatbot') {
    this.strategyType = strategyType
  }

  #strategies = {
    wizard: this.addToCartWizard,
    chatbot: this.addToCartChatbot
  }

  #validations = {
    productIds: (productIds: string[]): boolean => {
      if (!productIds || !Array.isArray(productIds) || productIds.length < 1) {
        logger.warn('Product ids are not valid.')
        return false
      }
      return true
    }
  }

  validate (customerId: string, productIds: string[]): boolean {
    return this.#validations.productIds(productIds)
  }

  async addToCartChatbot (customerId: string, subscriberId: string, productIds: string[]): Promise<boolean> {
    const addToCartFunction = geAddToCartFunction(customerId)

    try {
      for (const productId of productIds) {
        await addToCartFunction(customerId, subscriberId, productId)
      }
      await sendSpecialChatbot(customerId, subscriberId, 'addToCart')
      return true
    } catch (err) {
      await sendSpecialChatbot(customerId, subscriberId, 'addToCartFailed')
      return false
    }
  }

  async addToCartWizard (customerId: string, subscriberId: string, productIds: string[]): Promise<boolean> {
    const addToCartFunction = geAddToCartFunction(customerId)

    try {
      for (const productId of productIds) {
        await addToCartFunction(customerId, subscriberId, productId)
      }
      return true
    } catch (err) {
      return false
    }
  }

  execute (customerId: string, subscriberId: string, productIds: string[]): Promise<boolean> {
    if (!this.validate(customerId, productIds)) return Promise.resolve(false)

    logger.info(`Buying products ${productIds.join(', ')}...`)
    return this.#strategies[this.strategyType](customerId, subscriberId, productIds)
  }
}
